import React from 'react';
import { Box, Text } from '@chakra-ui/react';
var SelectionLabel = function SelectionLabel(_ref) {
  var className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'default label' : _ref$label;
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
    className: className
  }, label));
};
SelectionLabel.displayName = "SelectionLabel";
export { SelectionLabel };